import React from "react";

import { IGrade } from "../../../../state.d";

import ClassItem from "./ClassItem";
import styles from "./ClassGroup.module.scss";

export type Props = {
  gradeList: IGrade[];
  forward?: boolean;
  forwardData?: boolean;
  selectedClassIds?: number[];
  onChooseClass?: (id: number, assumed_entrance_year?: number) => void;
};

const ClassGroup: React.FC<Props> = ({
  gradeList,
  forward = false,
  forwardData = false,
  selectedClassIds = [],
  onChooseClass,
}) => {
  return (
    <div className={styles.groupClass}>
      {gradeList.length > 0 ? (
        <div className={styles.list}>
          {gradeList.map(group => (
            <div key={group.grade} className={styles.item}>
              <p className={styles.grade}>{group.grade} 年生</p>
              <div className={styles.inner}>
                {group.classes.map(klassName => (
                  <ClassItem
                    key={klassName.id}
                    klassName={klassName}
                    forward={forward}
                    forwardData={forwardData}
                    isActive={selectedClassIds.some(id => id === klassName.id)}
                    onChooseClass={onChooseClass}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className={styles.emptyMessage}>
          登録されているクラスがありません。管理画面からクラスを登録してください。
        </p>
      )}
    </div>
  );
};

export default ClassGroup;
